export default __webpack_public_path__ + "db735b19b35cb186933d35e615d229e0.svg";